import { adminService } from '../services/admin.service';
import { useApi } from './use-api';

export function useAdmin(adminId: string | undefined) {
  const { loading, result: admin, error } = useApi(adminService.get, adminId);
  return { loading, admin, error };
}
